<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ transactionsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : transactionsData.length }} of {{ transactionsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <date-picker
                  title-position="left"
                  color="#ffd100"
                  mode='range'

                  v-model='range'
                  :input-props='{
                      class: "vs-inputx vs-input--input normal",
                      placeholder: "search by date",
                      readonly: true
                  }'
              />
          <vs-input class="sm:mr-4 ml-3 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <!-- <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item> -->

              <!-- <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item> -->

            </vs-dropdown-menu>
          </vs-dropdown>
      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="transactionsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import moment from "moment"

// Store Module
import moduleTransactionManagement from '@/store/transaction-management/moduleTransactionManagement.js'

// Cell Renderer
import CellRendererOrder from "./cell-renderer/CellRendererOrder.vue"
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue"
import CellRendererPrice from "./cell-renderer/CellRendererPrice.vue"
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"



export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererOrder,
    CellRendererStatus,
    CellRendererPrice,
    CellRendererActions,
  },
  data() {
    return {
      range: {
        start: null,
        end: null
      },

      // statusFilter: { label: 'All', value: 'all' },
      // statusOptions: [
      //   { label: 'All', value: 'all' },
      //   { label: 'Active', value: 'active' },
      //   { label: 'Deactivated', value: 'deactivated' },
      //   { label: 'Blocked', value: 'blocked' },
      // ],

      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 125,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: 'Type',
          field: 'invoice_type',
          filter: true,
        },
        {
          headerName: 'Order Ref',
          field: 'order_ref',
          filter: true,
          cellRendererFramework: 'CellRendererOrder'
        },
        {
          headerName: 'Ordered On',
          field: 'created_at',
          filter: true
        },
        {
          headerName: 'Status',
          field: 'status',
          filter: true,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'Pay To Seller',
          field: 'amount_for_buyer',
          filter: true,
          cellRendererFramework: 'CellRendererPrice'

        },
        {
          headerName: 'Buyer Paid',
          field: 'amount_for_seller',
          filter: true,
          cellRendererFramework: 'CellRendererPrice'

        },
        {
          headerName: 'Actions',
          field: 'id',
          width: 125,
          cellRendererFramework: 'CellRendererActions',
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererOrder,
        CellRendererStatus,
        CellRendererPrice,
        CellRendererActions,
      }
    }
  },
  watch: {
    'range': function(n){
      if( n !== undefined && n.start !== null ){
          const filter = this.gridApi.getFilterInstance('created_at')
          let modelObj = { type: "contains", filter: moment().format("YYYY-MM-DD") }
          filter.setModel(modelObj)
          this.gridApi.onFilterChanged()
      }
    }
  },
  computed: {
    transactionsData() {
      return this.$store.state.transactionManagement.transactions
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if(val !== "all") {
        modelObj = { type: "equals", filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.range = { start: null , end: null }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {
    if(!moduleTransactionManagement.isRegistered) {
      this.$store.registerModule('transactionManagement', moduleTransactionManagement)
      moduleTransactionManagement.isRegistered = true
    }
    this.$store.dispatch("transactionManagement/fetchTransactions").catch(err => { console.error(err) })
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
